import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import JiraReferenceTypeList from './JiraReferenceTypeList';

const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  align-items: center;
  .title {
    flex: 1;
  }
`;

export interface JiraReferenceTypeListDialogProps {
  schemaKey: string | undefined;
  onClose: () => void;
  onClickType?: (schemaKey: string) => void;
}

const JiraReferenceTypeListDialog: React.FC<JiraReferenceTypeListDialogProps> = (
  props: JiraReferenceTypeListDialogProps
) => {
  const { schemaKey, onClose, onClickType } = props;
  const [contentRef, setContentRef] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    // go to top when schemaKey changes
    if (schemaKey && contentRef) {
      contentRef.scrollTop = 0;
    }
  }, [schemaKey, contentRef]);

  return (
    <Dialog maxWidth='md' open={!!schemaKey} onClose={onClose}>
      <StyledDialogTitle disableTypography>
        <Typography variant='h6' className='title'>
          <code>{schemaKey}</code>
        </Typography>
        <IconButton size='small' onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent
        style={{ padding: 0 }}
        innerRef={ref => setContentRef(ref)}
      >
        {schemaKey && (
          <JiraReferenceTypeList
            show
            keyOrIssueField={schemaKey}
            onClickType={onClickType}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default JiraReferenceTypeListDialog;
